import React, { useState, useEffect } from 'react';
import AnamnesisCatalogListMobile from './anamnesisCatalogListMobile';
import AnamnesisCatalogListWeb from './anamnesisCatalogListWeb';

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};

const AnamnesisCatalogListRouter = () => {
  const width = useWindowWidth();
  const MOBILE_BREAKPOINT = 768;

  return width < MOBILE_BREAKPOINT ? <AnamnesisCatalogListMobile /> : <AnamnesisCatalogListWeb />;
};

export default AnamnesisCatalogListRouter;
